import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box, Fade } from '@mui/material';

// Importa componenti
import HomePage from './components/HomePage';
import ProductList from './components/ProductList';
import VirtualTryOn from './components/VirtualTryOn';
import ProductDetail from './components/ProductDetail';
import Cart from './components/Cart';

// Nuovi componenti per QR flow
import QRGenerator from './components/QRGenerator';
import ProductLanding from './components/ProductLanding';
import PhotoCapture from './components/PhotoCapture';
import ContactCapture from './components/ContactCapture';
import TryOnResult from './components/TryOnResult';
import SavedItems from './components/SavedItems';
import BarcodeScanner from './components/BarcodeScanner';
import CatalogBrowse from './components/CatalogBrowse';
import StoreQuiz from './components/StoreQuiz';
import StoreCamera from './components/StoreCamera';
import ArmocromiaResults from './components/ArmocromiaResults';

// Admin components
import AdminDashboard from './components/AdminDashboard';
import AdminAddProduct from './components/AdminAddProduct';
import AdminPrintLabels from './components/AdminPrintLabels';
import AdminProductManager from './components/AdminProductManager';
import AdminCustomers from './components/AdminCustomers';
import AdminAnalytics from './components/AdminAnalytics';
import AdminLogin from './components/AdminLogin';
import ProtectedRoute from './components/ProtectedRoute';

import './App.css';

function AppContent() {
  const [cartItems, setCartItems] = React.useState(() => {
    return JSON.parse(localStorage.getItem('cartItems') || '[]');
  });

  const addToCart = (product) => {
    setCartItems(prev => {
      const existing = prev.find(item => item.id === product.id);
      let updated;
      if (existing) {
        updated = prev.map(item =>
          item.id === product.id ? { ...item, quantity: (item.quantity || 1) + 1 } : item
        );
      } else {
        updated = [...prev, { ...product, quantity: 1 }];
      }
      localStorage.setItem('cartItems', JSON.stringify(updated));
      return updated;
    });
  };

  const removeFromCart = (productId) => {
    setCartItems(prev => {
      const updated = prev.filter(item => item.id !== productId);
      localStorage.setItem('cartItems', JSON.stringify(updated));
      return updated;
    });
  };

  const location = useLocation();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Fade key={location.pathname} in timeout={220}>
        <Box>
      <Routes location={location}>
        {/* Landing page - mostrata solo su / */}
        <Route path="/" element={<HomePage />} />

        {/* === ADMIN DASHBOARD === */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={
          <ProtectedRoute requireAdmin={true}>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin/add-product" element={
          <ProtectedRoute requireAdmin={true}>
            <AdminAddProduct />
          </ProtectedRoute>
        } />
        <Route path="/admin/qr-generator" element={
          <ProtectedRoute requireAdmin={true}>
            <QRGenerator />
          </ProtectedRoute>
        } />
        <Route path="/admin/print-labels" element={
          <ProtectedRoute requireAdmin={true}>
            <AdminPrintLabels />
          </ProtectedRoute>
        } />
        <Route path="/admin/scan-barcode" element={
          <ProtectedRoute requireAdmin={true}>
            <BarcodeScanner />
          </ProtectedRoute>
        } />
        <Route path="/admin/products" element={
          <ProtectedRoute requireAdmin={true}>
            <ProductList addToCart={() => {}} />
          </ProtectedRoute>
        } />
        <Route path="/admin/manage-products" element={
          <ProtectedRoute requireAdmin={true}>
            <AdminProductManager />
          </ProtectedRoute>
        } />
        <Route path="/admin/customers" element={
          <ProtectedRoute requireAdmin={true}>
            <AdminCustomers />
          </ProtectedRoute>
        } />
        <Route path="/admin/analytics" element={
          <ProtectedRoute requireAdmin={true}>
            <AdminAnalytics />
          </ProtectedRoute>
        } />

        {/* === NUOVO FLOW PROVAMI === */}
        {/* Catalogo sfogliabile */}
        <Route path="/catalogo" element={<CatalogBrowse />} />

        {/* Scanner universale (QR + Barcode) */}
        <Route path="/scan" element={<BarcodeScanner />} />

        {/* Product landing dopo scan QR/Barcode */}
        <Route path="/try" element={<ProductLanding />} />

        {/* Cattura foto */}
        <Route path="/photo-capture" element={<PhotoCapture />} />

        {/* Cattura contatto */}
        <Route path="/contact" element={<ContactCapture />} />

        {/* Redirect retrocompatibilità camera-tryon → photo-capture */}
        <Route path="/camera-tryon" element={<Navigate to="/photo-capture" replace />} />

        {/* Risultato try-on */}
        <Route path="/try-on-result" element={<TryOnResult />} />

        {/* Saved items / Wishlist */}
        <Route path="/saved-items" element={<SavedItems />} />

        {/* === ARMOCROMIA IN-STORE FLOW === */}
        <Route path="/store-quiz" element={<StoreQuiz />} />
        <Route path="/store-camera" element={<StoreCamera />} />
        <Route path="/armocromia-results" element={<ArmocromiaResults />} />

        {/* === ALTRE PAGINE === */}
        <Route path="/products" element={<ProductList addToCart={addToCart} />} />
        <Route path="/product/:id" element={<ProductDetail addToCart={addToCart} />} />
        <Route path="/try-on" element={<VirtualTryOn />} />
        <Route path="/cart" element={<Cart cartItems={cartItems} removeFromCart={removeFromCart} setCartItems={setCartItems} />} />

        {/* 404 catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
        </Box>
      </Fade>
    </Box>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
